import React from "react";
import { motion } from "framer-motion";
import { X } from "lucide-react";
import EditableField from "./EditableField";
import RepeatPreview from "./RepeatPreview";

const TaskDetailDrawer = ({
    task,
    onClose,
    onUpdateField,
    leadOptions,
    assignOptions,
    apiUrl,
    role,
    TaskHistory,
}) => {
    if (!task) return null;

    const readOnly = role === "staff" && task.assigned_by === "Admin";

    const fields = [
        { label: "Title", field: "title" },
        { label: "Due Date", field: "due_date" },
        { label: "Repetition", field: "repetition" },
        { label: "Priority", field: "priority" },
        { label: "Assign To", field: "assign_to" },
        { label: "Add to List", field: "list_id" },
        { label: "Notes", field: "notes", fullWidth: true },
        { label: "Attachment", field: "attachment", fullWidth: true },
    ];

    return (
        <>
            <motion.div
                initial={{ x: "100%", opacity: 0.9 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: "100%", opacity: 0.9 }}
                transition={{ type: "tween", duration: 0.28 }}
                className="task-detail-drawer"
            >
                <div className="task-detail-drawer__header">
                    <h2 className="text-base font-semibold text-ink truncate">Task Details</h2>
                    <button
                        type="button"
                        onClick={onClose}
                        className="task-detail-drawer__close"
                        aria-label="Close task details"
                    >
                        <X size={20} />
                    </button>
                </div>

                <div className="task-detail-drawer__body">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                        {fields.map(({ label, field, fullWidth }) => (
                            <div
                                key={field}
                                className={fullWidth ? "col-span-1 md:col-span-2" : ""}
                            >
                                <p className="font-medium text-ink-muted text-xs mb-0.5">
                                    {label}
                                </p>
                                <EditableField
                                    value={task[field]}
                                    field={field}
                                    onChange={(val) => onUpdateField(task.id, field, val)}
                                    leadOptions={leadOptions}
                                    assignOptions={assignOptions}
                                    assignedBy={task.assigned_by}
                                    apiUrl={apiUrl}
                                    readOnly={readOnly}
                                />
                            </div>
                        ))}
                    </div>
                    <RepeatPreview task={task} />
                    {TaskHistory && (
                        <TaskHistory history={task?.historyTasks || []} />
                    )}
                </div>
            </motion.div>
            <div
                className="task-detail-drawer__backdrop lg:hidden"
                onClick={onClose}
                aria-hidden
            />
        </>
    );
};

export default TaskDetailDrawer;
